import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddLevelComp from "./Component/AddLevelComp"


const AddLevel =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddLevelComp />
        </div>
        <Footer />
        </>
    )
}

export default AddLevel